// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all_content_article_create {
  width: 70%;
}

.article_create_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;
  background: var(--white-principale);
}

.article_create_title {
  color: var(--couleur-principale);
  font-weight: 700;
}

.article_create_subtitle {
  color: var(--couleur-principale);
  font-weight: 700;
  text-align: center;
  margin: 40px 0px;
}

.article_create_stepper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background: var(--white-principale);
  scrollbar-width: none;
  overflow-x: none;
}

.article_create_step_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  position: relative;
  margin-left: 20px;
}

.article_create_step_circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--gris-principale);
  color: var(--white-principale);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: bold;
  z-index: 2;
  transition: 0.3s;
}

.article_create_step_item.active .article_create_step_circle {
  background: var(--couleur-secondaire);
  color: var(--white-principale);
  transform: scale(1);
  box-shadow:
    0 0 2px var(--couleur-secondaire),
    0 0 10px var(--couleur-secondaire),
    0 0 10px var(--couleur-secondaire);
}

.article_create_step_item.completed .article_create_step_circle {
  background: var(--gris-principale);
  color: var(--white-principale);
}

.article_create_step_label {
  font-size: 0.7rem;
  color: var(--gris-principale);
  font-weight: 500;
}

.article_create_content {
  padding: 20px;
}

.article_create_form_section_create label {
  display: block;
  font-weight: 600;
  margin-bottom: 10px;
  /* width: 25%; */
  text-align: center;
}

.article_create_modern_input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid var(--gris-terciaire);
  border-radius: 15px;
  background: var(--white-principale);
  font-size: 1rem;
  margin-bottom: 12px;
  transition: border 0.3s;
  color: var(--gris-tertiaire-2);
}

.article_create_modern_input:focus {
  border: 1px solid var(--gris-terciaire);
  outline: none;
  box-shadow: 0 0 0 0;
}

.article_create_modern_textarea {
  min-height: 180px;
  resize: none;
}

.article_create_photo_grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 10px;
}

.article_create_photo_card,
.article_create_photo_upload-card {
  aspect-ratio: 1/1;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  background: var(--gris-secondaire);
}

.article_create_photo_card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.article_create_remove_btn {
  position: absolute;
  top: 2px;
  right: 2px;
  background: var(--white-rgba);
  border: none;
  border-radius: 50%;
  color: var(--couleur-secondaire);
  cursor: pointer;
  padding: 2px;
}

.article_create_photo_upload_card {
  border: 2px dashed var(--couleur-secondaire);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--couleur-secondaire);
  cursor: pointer;
}

.article_create_photo_upload_card span {
  font-size: 0.7rem;
  font-weight: 600;
}

.photo-flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.photo-card-flex,
.photo-upload-card-flex {
  width: 20%;
  aspect-ratio: 1/1;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  border: 2px dashed var(--couleur-dark);
  cursor: pointer;
}

.photo-upload-card-flex:hover {
  border: 2px dashed var(--couleur-secondaire);
}

.photo-flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: start;
}

.photo-card-flex {
  width: 20%;
  aspect-ratio: 1/1;
  position: relative;
  border-radius: 12px;
  background: #000;
}

.photo-uploaded {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  opacity: 0.85;
}

.photo-controls {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  background: var(--gris-terciaire);
  padding: 0px;
  border-radius: 0 0 12px 12px;
}

.photo-controls button {
  background: none;
  border: none;
  color: var(--white-principale);
  cursor: pointer;
  font-size: 1.1rem;
}

.photo-controls .btn-del {
  color: var(--couleur-secondaire);
}

.photo-controls button:disabled {
  opacity: 0.3;
}

.content-btn-add-photo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
}

.icon_add_photo {
  font-size: 2.5rem;
  color: var(--couleur-secondaire);
}

.main_label_principale {
  position: absolute;
  top: 5px;
  left: 5px;
  background: var(--couleur-principale);
  color: var(--white-principale);
  font-size: 0.6rem;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
}

.article_create_footer {
  padding: 20px;
  background: var(--white);
  /* border-top: 1px solid var(--border); */
  display: flex;
  justify-content: space-between;
  gap: 15px;
}

.article_create_btn_continuer,
.article_create_btn_retour {
  padding: 12px 25px;
  border-radius: 30px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  margin-top: 10px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}

.article_create_btn_continuer {
  background: var(--couleur-principale);
  color: var(--white-principale);
  flex: 3 1;
  justify-content: center;
}

.article_create_btn_continuer:hover {
  background: var(--couleur-secondaire);
}

.article_create_btn_continuer.disabled {
  background: var(--gris-secondaire) !important;
  cursor: not-allowed;
  opacity: 0.6;
}

.article_create_btn_retour {
  background: var(--gris-secondaire);
  color: var(--text-main);
  flex: 1 1;
}

/* info cle */
.info-cle-picker {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  height: 300px;
  overflow-y: auto;
}

.icon-choice {
  border: 1px solid var(--gris-secondaire);
  padding: 8px;
  border-radius: 10px;
  background: var(--white-principale);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--gris-terciaire);
}

.icon-choice span {
  color: var(--gris-terciaire);
}

.icon-choice.active {
  border-color: var(--couleur-principale);
  background: var(--white-principale);
}

.info-cle-input {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.btn-add-info {
  background: var(--couleur-principale);
  color: var(--white-principale);
  border-radius: 15px;
  padding: 0 14px;
  border: none;
  height: 50px;
}

.info-cle-list {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.info-cle-chip {
  background: var(--white-principale);
  border-radius: 20px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.fade-in {
  animation: fadeIn 0.25s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Recap create */
.content_article_create_info {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
}

.preview_card {
  overflow: hidden;
  width: 45%;
}

.main_preview_img {
  width: 222px;
  height: 200px;
  object-fit: cover;
}

.preview_details {
  padding: 15px;
}

.preview_badge {
  background: var(--white-principale);
  padding: 4px 10px;
  border-radius: 50px;
  font-size: 0.75rem;
}

.preview_price {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--couleur-secondaire);
  margin: 10px 0;
}

.recap_gallery_container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 290px;
}

.recap_flex {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  position: relative;
}

.recap_img_large {
  flex-shrink: 0;
  width: auto;
  object-fit: cover;
  border-radius: 10px;
  height: 100%;
}

.more_photos_overlay {
  color: var(--white-principale);
  cursor: pointer;
}

.btn_show_less {
  width: 100%;
  margin-top: 10px;
  background: var(--gris-secondaire);
  border: none;
  padding: 8px;
  border-radius: 8px;
  font-weight: 600;
}

.recap_carousel {
  display: flex;
  gap: 12px;
  transition: transform 0.35s ease;
  height: 100%;
}

.carousel_btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 22px;
  z-index: 2;
}

.carousel_btn.left {
  left: 8px;
}

.carousel_btn.right {
  right: 8px;
}

.preview_info_cle {
  height: 427px;
  width: 45%;
}

.info_cle_section {
  background-color: var(--white-principale);
  border: 1 px solid var(--gris-secondaire);
  border-radius: 15px;
  padding: 15px;
  width: 100%;
  box-shadow:
    #00000029 0px 1px 3px,
    #0000001a 0px 1px 2px;
  height: 290px;
  overflow-y: auto;
}

.titre_recap_infos_cle {
  color: var(--violet-secondaire);
  font-weight: 400;
  font-size: 20px;
}

.titre_recap_description {
  color: var(--violet-secondaire);
  font-weight: 600;
  font-size: 25px;
}

.info_cle_table {
  display: grid;
  row-gap: 10px;
  margin-top: 10px;
}

.info_cle_row {
  display: grid;
  grid-template-columns: 24px 160px 1fr;
  align-items: center;
  gap: 12px;
}

.info_cle_icon i {
  font-size: 1.1rem;
  color: var(--couleur-secondaire);
}

.info_cle_name {
  font-weight: 600;
  color: var(--couleur-dark);
  white-space: nowrap;
}

.info_cle_value {
  color: var(--text-main);
  word-break: break-word;
}

/* --- Paiement Dynamique --- */

.payment-group {
  margin-bottom: 10px;
}

.payment-input {
  margin-top: 8px;
  border: 2px solid var(--couleur-principale);
  animation: slideDown 0.3s ease;
}

.btn-loading {
  display: flex;
  align-items: center;
  gap: 10px;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 3px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* --- Paiement Dynamique --- */
.payment_instructions {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.payment_group {
  margin-bottom: 10px;
}

.payment_input {
  margin-top: 8px;
  border: 2px solid var(--couleur-dark);
  animation: slideDown 0.3s ease;
  width: 100%;
  border: 1px solid var(--gris-terciaire);
  border-radius: 10px;
  padding: 10px;
  font-size: 1rem;
}

.payment_methods_flex {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.payment_note {
  flex: 3 1;
}

.payment_box {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 2px solid var(--gris-secondaire);
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 10px;
  transition: border 0.3s;
  width: 200px;
  height: 100px;
  object-fit: cover;
}

.payment_image {
  width: 90%;
  height: auto;
}

.payment_detail_input_group {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.content_total_a_payer {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--couleur-secondaire);
  /* border: 1px solid var(--gris-secondaire); */
  padding: 10px 0;
  border-radius: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.content_form_paiement {
  border: 1px solid var(--gris-secondaire);
  padding: 10px;
  border-radius: 10px;
  width: 100%;
  min-height: 300px;
  margin-top: 10px;
  text-align: center;
  height: 40%;
}

.content_form_paiement label {
  font-weight: 600;
  margin-top: 10px;
  display: block;
  font-size: 1.6rem;
  color: var(--couleur-dark);
}

.payment_row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  /* Permet de passer sur une seule colonne sur mobile */
}

.payment_col {
  flex: 1 1;
  /* Chaque champ prend 50% si espace suffisant */
  min-width: 120px;
  /* Minimum pour que ce soit lisible sur mobile */
}

/* STEP 4 Terminer */
.article_success_wrapper {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.article_success_card {
  background: transparent;
  padding: 40px 30px;
  max-width: 480px;
  width: 100%;
  text-align: center;
}

.success_icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #28a745, #3bd671);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: var(--white-principale);
}

.success_title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
  color: var(--couleur-dark);
}

.success_description {
  font-size: 15px;
  color: var(--gris-principale);
  margin-bottom: 30px;
  line-height: 1.6;
}

.success_actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

/* Boutons */
.article_success_btn_primary {
  background: var(--couleur-secondaire);
  color: var(--white-principale);
  border: none;
  padding: 12px 20px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.article_success_btn_primary:hover {
  background: var(--couleur-secondaire);
  transform: translateY(-1px);
}

.article_success_btn_secondary {
  background: var(--white-terciaire);
  color: var(--couleur-dark);
  border: none;
  padding: 12px 20px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.article_success_btn_secondary:hover {
  background: var(--white-principale);
}

/* SELECTION CATEGORIE */
.custom-category-select {
  position: relative;
}

.category-input-display {
  height: 50px;
  border: 1px solid var(--gris-secondaire-3);
  border-radius: 15px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
  background: var(--white-principale);
  margin-bottom: 10px;
  color: var(--gris-tertiaire-2);
}

.category-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--gris-tertiaire-2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.category-modal-box {
  width: 800px;
  height: 500px;
  background: var(--white-principale);
  border-radius: 20px;
  display: flex;
  position: relative;
  overflow: hidden;
  margin: 0px 10px;
}

.category-left {
  width: 40%;
  border-right: 1px solid var(--white-secondaire);
  overflow-y: auto;
  padding: 5px 0px;
}

.category-right {
  width: 60%;
  padding: 20px;
  overflow-y: auto;
}

.category-group-item {
  padding: 15px;
  cursor: pointer;
  transition: 0.2s;
}

.category-group-item:hover {
  background: var(--white-tertiaire-1);
}

.category-group-item.active {
  color: var(--couleur-secondaire);
  border-left: 6px solid var(--couleur-secondaire);
  display: flex;
  justify-content: space-between;
}

.category-sub-item {
  padding: 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.category-sub-item:hover {
  background: var(--white-tertiaire);
}

.category-close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  border: none;
  background: var(--couleur-secondaire);
  color: var(--white-principale);
  border-radius: 50%;
  width: 30px;
  height: 30px;
}

.fleche-icon {
  color: var(--couleur-secondaire);
  font-size: 16px;
}

.content_description {
  max-height: 358px;
  overflow-y: auto;
}

/* Option article de test */
.article_test_option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  background: var(--white-principale);
  border: 1px solid var(--gris-secondaire);
  border-radius: 15px;
  padding: 14px 16px;
  margin-top: 15px;
}

.article_test_option_text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.article_test_option_title {
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--couleur-dark);
}

.article_test_option_desc {
  font-size: 0.75rem;
  color: var(--gris-principale);
}

.article_test_switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 26px;
  flex-shrink: 0;
}

.article_test_switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.article_test_switch_slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: var(--gris-secondaire);
  border-radius: 30px;
  transition: 0.3s;
}

.article_test_switch_slider::before {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: var(--white-principale);
  border-radius: 50%;
  transition: 0.3s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.article_test_switch input:checked+.article_test_switch_slider {
  background-color: var(--couleur-secondaire);
}

.article_test_switch input:checked+.article_test_switch_slider::before {
  transform: translateX(10px);
}

/* Mobile */
@media (max-width: 480px) {
  .article_success_card {
    padding: 30px 20px;
  }

  .success_title {
    font-size: 20px;
  }
}

/* responsivité */

@media (max-width: 1200px) {
  .content_article_create_info {
    flex-direction: column;
  }

  .preview_card {
    width: 100%;
  }

  .preview_info_cle {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .all_content_article_create {
    width: 100%;
  }

  .recap_carousel {
    gap: 2px;
  }

  .article_create_stepper {
    flex-direction: row !important;
  }
}

@media (max-width: 991px) {
  .recap_img_large {
    width: calc((100%) / 2);
  }
}

@media (max-width: 576px) {
  .recap_img_large {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .all_content_article_create {
    width: 100%;
  }

  .article_create_stepper {
    overflow-x: auto;
  }

  .article_create_step_circle {
    width: 35px;
    height: 31px;
  }

  .article_create_step_item {
    gap: 7px;
    justify-content: center;
  }

  .article_create_step_item.active .article_create_step_circle {
    transform: scale(1.15);
  }

  .recap_img_large {
    flex: 0 0 100%;
  }

  .info_cle_row {
    grid-template-columns: 20px 120px 1fr;
    gap: 8px;
  }

  .info_cle_name {
    font-size: 0.85rem;
  }

  .info_cle_value {
    font-size: 0.85rem;
  }

  .photo-flex-container {
    justify-content: center;
  }

  .photo-upload-card-flex {
    width: 50%;
  }

  .main_label_principale {
    top: 0;
    left: 0;
  }

  .article_create_form_section_create label {
    width: 48%;
  }

  .photo-card-flex {
    width: 47%;
  }

  .carousel_btn.right {
    right: 5px;
  }

  .payment_instructions {
    flex-direction: column;
  }

  .payment_methods_flex {
    flex-direction: row;
    gap: 5px;
  }

  .payment_box {
    width: 80px;
    height: 50px;
    gap: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/article/ArticleCreate.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mCAAmC;EACnC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;EACnB;;;sCAGoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,SAAO;AACT;;AAEA,aAAa;AACb;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX;;yBAEuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,+BAA+B;;AAE/B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,8BAA8B;EAC9B,WAAW;EACX,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,8CAA8C;EAC9C,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,SAAO;EACP,+CAA+C;EAC/C,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;EAChD,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;;AAEjB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,MAAM;IACN,OAAO;EACT;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;AACF","sourcesContent":[".all_content_article_create {\n  width: 70%;\n}\n\n.article_create_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 20px;\n  background: var(--white-principale);\n}\n\n.article_create_title {\n  color: var(--couleur-principale);\n  font-weight: 700;\n}\n\n.article_create_subtitle {\n  color: var(--couleur-principale);\n  font-weight: 700;\n  text-align: center;\n  margin: 40px 0px;\n}\n\n.article_create_stepper {\n  display: flex;\n  justify-content: space-between;\n  padding: 20px;\n  background: var(--white-principale);\n  scrollbar-width: none;\n  overflow-x: none;\n}\n\n.article_create_step_item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  position: relative;\n  margin-left: 20px;\n}\n\n.article_create_step_circle {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: var(--gris-principale);\n  color: var(--white-principale);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  font-weight: bold;\n  z-index: 2;\n  transition: 0.3s;\n}\n\n.article_create_step_item.active .article_create_step_circle {\n  background: var(--couleur-secondaire);\n  color: var(--white-principale);\n  transform: scale(1);\n  box-shadow:\n    0 0 2px var(--couleur-secondaire),\n    0 0 10px var(--couleur-secondaire),\n    0 0 10px var(--couleur-secondaire);\n}\n\n.article_create_step_item.completed .article_create_step_circle {\n  background: var(--gris-principale);\n  color: var(--white-principale);\n}\n\n.article_create_step_label {\n  font-size: 0.7rem;\n  color: var(--gris-principale);\n  font-weight: 500;\n}\n\n.article_create_content {\n  padding: 20px;\n}\n\n.article_create_form_section_create label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 10px;\n  /* width: 25%; */\n  text-align: center;\n}\n\n.article_create_modern_input {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid var(--gris-terciaire);\n  border-radius: 15px;\n  background: var(--white-principale);\n  font-size: 1rem;\n  margin-bottom: 12px;\n  transition: border 0.3s;\n  color: var(--gris-tertiaire-2);\n}\n\n.article_create_modern_input:focus {\n  border: 1px solid var(--gris-terciaire);\n  outline: none;\n  box-shadow: 0 0 0 0;\n}\n\n.article_create_modern_textarea {\n  min-height: 180px;\n  resize: none;\n}\n\n.article_create_photo_grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  gap: 10px;\n}\n\n.article_create_photo_card,\n.article_create_photo_upload-card {\n  aspect-ratio: 1/1;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n  background: var(--gris-secondaire);\n}\n\n.article_create_photo_card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.article_create_remove_btn {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: var(--white-rgba);\n  border: none;\n  border-radius: 50%;\n  color: var(--couleur-secondaire);\n  cursor: pointer;\n  padding: 2px;\n}\n\n.article_create_photo_upload_card {\n  border: 2px dashed var(--couleur-secondaire);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--couleur-secondaire);\n  cursor: pointer;\n}\n\n.article_create_photo_upload_card span {\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.photo-flex-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.photo-card-flex,\n.photo-upload-card-flex {\n  width: 20%;\n  aspect-ratio: 1/1;\n  border-radius: 10px;\n  position: relative;\n  overflow: hidden;\n  border: 2px dashed var(--couleur-dark);\n  cursor: pointer;\n}\n\n.photo-upload-card-flex:hover {\n  border: 2px dashed var(--couleur-secondaire);\n}\n\n.photo-flex-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: start;\n}\n\n.photo-card-flex {\n  width: 20%;\n  aspect-ratio: 1/1;\n  position: relative;\n  border-radius: 12px;\n  background: #000;\n}\n\n.photo-uploaded {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  opacity: 0.85;\n}\n\n.photo-controls {\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-around;\n  background: var(--gris-terciaire);\n  padding: 0px;\n  border-radius: 0 0 12px 12px;\n}\n\n.photo-controls button {\n  background: none;\n  border: none;\n  color: var(--white-principale);\n  cursor: pointer;\n  font-size: 1.1rem;\n}\n\n.photo-controls .btn-del {\n  color: var(--couleur-secondaire);\n}\n\n.photo-controls button:disabled {\n  opacity: 0.3;\n}\n\n.content-btn-add-photo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n}\n\n.icon_add_photo {\n  font-size: 2.5rem;\n  color: var(--couleur-secondaire);\n}\n\n.main_label_principale {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  background: var(--couleur-principale);\n  color: var(--white-principale);\n  font-size: 0.6rem;\n  padding: 2px 6px;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n.article_create_footer {\n  padding: 20px;\n  background: var(--white);\n  /* border-top: 1px solid var(--border); */\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n}\n\n.article_create_btn_continuer,\n.article_create_btn_retour {\n  padding: 12px 25px;\n  border-radius: 30px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: none;\n  margin-top: 10px;\n  width: 100%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 5px;\n}\n\n.article_create_btn_continuer {\n  background: var(--couleur-principale);\n  color: var(--white-principale);\n  flex: 3;\n  justify-content: center;\n}\n\n.article_create_btn_continuer:hover {\n  background: var(--couleur-secondaire);\n}\n\n.article_create_btn_continuer.disabled {\n  background: var(--gris-secondaire) !important;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.article_create_btn_retour {\n  background: var(--gris-secondaire);\n  color: var(--text-main);\n  flex: 1;\n}\n\n/* info cle */\n.info-cle-picker {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 10px;\n  height: 300px;\n  overflow-y: auto;\n}\n\n.icon-choice {\n  border: 1px solid var(--gris-secondaire);\n  padding: 8px;\n  border-radius: 10px;\n  background: var(--white-principale);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--gris-terciaire);\n}\n\n.icon-choice span {\n  color: var(--gris-terciaire);\n}\n\n.icon-choice.active {\n  border-color: var(--couleur-principale);\n  background: var(--white-principale);\n}\n\n.info-cle-input {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.btn-add-info {\n  background: var(--couleur-principale);\n  color: var(--white-principale);\n  border-radius: 15px;\n  padding: 0 14px;\n  border: none;\n  height: 50px;\n}\n\n.info-cle-list {\n  margin-top: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.info-cle-chip {\n  background: var(--white-principale);\n  border-radius: 20px;\n  padding: 6px 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.fade-in {\n  animation: fadeIn 0.25s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Recap create */\n.content_article_create_info {\n  display: flex;\n  justify-content: space-around;\n  flex-direction: row;\n}\n\n.preview_card {\n  overflow: hidden;\n  width: 45%;\n}\n\n.main_preview_img {\n  width: 222px;\n  height: 200px;\n  object-fit: cover;\n}\n\n.preview_details {\n  padding: 15px;\n}\n\n.preview_badge {\n  background: var(--white-principale);\n  padding: 4px 10px;\n  border-radius: 50px;\n  font-size: 0.75rem;\n}\n\n.preview_price {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--couleur-secondaire);\n  margin: 10px 0;\n}\n\n.recap_gallery_container {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 290px;\n}\n\n.recap_flex {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 8px;\n  position: relative;\n}\n\n.recap_img_large {\n  flex-shrink: 0;\n  width: auto;\n  object-fit: cover;\n  border-radius: 10px;\n  height: 100%;\n}\n\n.more_photos_overlay {\n  color: var(--white-principale);\n  cursor: pointer;\n}\n\n.btn_show_less {\n  width: 100%;\n  margin-top: 10px;\n  background: var(--gris-secondaire);\n  border: none;\n  padding: 8px;\n  border-radius: 8px;\n  font-weight: 600;\n}\n\n.recap_carousel {\n  display: flex;\n  gap: 12px;\n  transition: transform 0.35s ease;\n  height: 100%;\n}\n\n.carousel_btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 22px;\n  z-index: 2;\n}\n\n.carousel_btn.left {\n  left: 8px;\n}\n\n.carousel_btn.right {\n  right: 8px;\n}\n\n.preview_info_cle {\n  height: 427px;\n  width: 45%;\n}\n\n.info_cle_section {\n  background-color: var(--white-principale);\n  border: 1 px solid var(--gris-secondaire);\n  border-radius: 15px;\n  padding: 15px;\n  width: 100%;\n  box-shadow:\n    #00000029 0px 1px 3px,\n    #0000001a 0px 1px 2px;\n  height: 290px;\n  overflow-y: auto;\n}\n\n.titre_recap_infos_cle {\n  color: var(--violet-secondaire);\n  font-weight: 400;\n  font-size: 20px;\n}\n\n.titre_recap_description {\n  color: var(--violet-secondaire);\n  font-weight: 600;\n  font-size: 25px;\n}\n\n.info_cle_table {\n  display: grid;\n  row-gap: 10px;\n  margin-top: 10px;\n}\n\n.info_cle_row {\n  display: grid;\n  grid-template-columns: 24px 160px 1fr;\n  align-items: center;\n  gap: 12px;\n}\n\n.info_cle_icon i {\n  font-size: 1.1rem;\n  color: var(--couleur-secondaire);\n}\n\n.info_cle_name {\n  font-weight: 600;\n  color: var(--couleur-dark);\n  white-space: nowrap;\n}\n\n.info_cle_value {\n  color: var(--text-main);\n  word-break: break-word;\n}\n\n/* --- Paiement Dynamique --- */\n\n.payment-group {\n  margin-bottom: 10px;\n}\n\n.payment-input {\n  margin-top: 8px;\n  border: 2px solid var(--couleur-principale);\n  animation: slideDown 0.3s ease;\n}\n\n.btn-loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.spinner {\n  width: 18px;\n  height: 18px;\n  border: 3px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* --- Paiement Dynamique --- */\n.payment_instructions {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n}\n\n.payment_group {\n  margin-bottom: 10px;\n}\n\n.payment_input {\n  margin-top: 8px;\n  border: 2px solid var(--couleur-dark);\n  animation: slideDown 0.3s ease;\n  width: 100%;\n  border: 1px solid var(--gris-terciaire);\n  border-radius: 10px;\n  padding: 10px;\n  font-size: 1rem;\n}\n\n.payment_methods_flex {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.payment_note {\n  flex: 3;\n}\n\n.payment_box {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  border: 2px solid var(--gris-secondaire);\n  border-radius: 10px;\n  cursor: pointer;\n  margin-bottom: 10px;\n  transition: border 0.3s;\n  width: 200px;\n  height: 100px;\n  object-fit: cover;\n}\n\n.payment_image {\n  width: 90%;\n  height: auto;\n}\n\n.payment_detail_input_group {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.content_total_a_payer {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--couleur-secondaire);\n  /* border: 1px solid var(--gris-secondaire); */\n  padding: 10px 0;\n  border-radius: 10px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.content_form_paiement {\n  border: 1px solid var(--gris-secondaire);\n  padding: 10px;\n  border-radius: 10px;\n  width: 100%;\n  min-height: 300px;\n  margin-top: 10px;\n  text-align: center;\n  height: 40%;\n}\n\n.content_form_paiement label {\n  font-weight: 600;\n  margin-top: 10px;\n  display: block;\n  font-size: 1.6rem;\n  color: var(--couleur-dark);\n}\n\n.payment_row {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  /* Permet de passer sur une seule colonne sur mobile */\n}\n\n.payment_col {\n  flex: 1;\n  /* Chaque champ prend 50% si espace suffisant */\n  min-width: 120px;\n  /* Minimum pour que ce soit lisible sur mobile */\n}\n\n/* STEP 4 Terminer */\n.article_success_wrapper {\n  min-height: 70vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.article_success_card {\n  background: transparent;\n  padding: 40px 30px;\n  max-width: 480px;\n  width: 100%;\n  text-align: center;\n}\n\n.success_icon {\n  width: 72px;\n  height: 72px;\n  margin: 0 auto 20px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #28a745, #3bd671);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 36px;\n  color: var(--white-principale);\n}\n\n.success_title {\n  font-size: 22px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  color: var(--couleur-dark);\n}\n\n.success_description {\n  font-size: 15px;\n  color: var(--gris-principale);\n  margin-bottom: 30px;\n  line-height: 1.6;\n}\n\n.success_actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n/* Boutons */\n.article_success_btn_primary {\n  background: var(--couleur-secondaire);\n  color: var(--white-principale);\n  border: none;\n  padding: 12px 20px;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.article_success_btn_primary:hover {\n  background: var(--couleur-secondaire);\n  transform: translateY(-1px);\n}\n\n.article_success_btn_secondary {\n  background: var(--white-terciaire);\n  color: var(--couleur-dark);\n  border: none;\n  padding: 12px 20px;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.article_success_btn_secondary:hover {\n  background: var(--white-principale);\n}\n\n/* SELECTION CATEGORIE */\n.custom-category-select {\n  position: relative;\n}\n\n.category-input-display {\n  height: 50px;\n  border: 1px solid var(--gris-secondaire-3);\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n  cursor: pointer;\n  background: var(--white-principale);\n  margin-bottom: 10px;\n  color: var(--gris-tertiaire-2);\n}\n\n.category-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--gris-tertiaire-2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.category-modal-box {\n  width: 800px;\n  height: 500px;\n  background: var(--white-principale);\n  border-radius: 20px;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n  margin: 0px 10px;\n}\n\n.category-left {\n  width: 40%;\n  border-right: 1px solid var(--white-secondaire);\n  overflow-y: auto;\n  padding: 5px 0px;\n}\n\n.category-right {\n  width: 60%;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.category-group-item {\n  padding: 15px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.category-group-item:hover {\n  background: var(--white-tertiaire-1);\n}\n\n.category-group-item.active {\n  color: var(--couleur-secondaire);\n  border-left: 6px solid var(--couleur-secondaire);\n  display: flex;\n  justify-content: space-between;\n}\n\n.category-sub-item {\n  padding: 12px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.category-sub-item:hover {\n  background: var(--white-tertiaire);\n}\n\n.category-close-btn {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  border: none;\n  background: var(--couleur-secondaire);\n  color: var(--white-principale);\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n}\n\n.fleche-icon {\n  color: var(--couleur-secondaire);\n  font-size: 16px;\n}\n\n.content_description {\n  max-height: 358px;\n  overflow-y: auto;\n}\n\n/* Option article de test */\n.article_test_option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  background: var(--white-principale);\n  border: 1px solid var(--gris-secondaire);\n  border-radius: 15px;\n  padding: 14px 16px;\n  margin-top: 15px;\n}\n\n.article_test_option_text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.article_test_option_title {\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: var(--couleur-dark);\n}\n\n.article_test_option_desc {\n  font-size: 0.75rem;\n  color: var(--gris-principale);\n}\n\n.article_test_switch {\n  position: relative;\n  display: inline-block;\n  width: 46px;\n  height: 26px;\n  flex-shrink: 0;\n}\n\n.article_test_switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.article_test_switch_slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background-color: var(--gris-secondaire);\n  border-radius: 30px;\n  transition: 0.3s;\n}\n\n.article_test_switch_slider::before {\n  content: \"\";\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  bottom: 3px;\n  background-color: var(--white-principale);\n  border-radius: 50%;\n  transition: 0.3s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.article_test_switch input:checked+.article_test_switch_slider {\n  background-color: var(--couleur-secondaire);\n}\n\n.article_test_switch input:checked+.article_test_switch_slider::before {\n  transform: translateX(10px);\n}\n\n/* Mobile */\n@media (max-width: 480px) {\n  .article_success_card {\n    padding: 30px 20px;\n  }\n\n  .success_title {\n    font-size: 20px;\n  }\n}\n\n/* responsivité */\n\n@media (max-width: 1200px) {\n  .content_article_create_info {\n    flex-direction: column;\n  }\n\n  .preview_card {\n    width: 100%;\n  }\n\n  .preview_info_cle {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .all_content_article_create {\n    width: 100%;\n  }\n\n  .recap_carousel {\n    gap: 2px;\n  }\n\n  .article_create_stepper {\n    flex-direction: row !important;\n  }\n}\n\n@media (max-width: 991px) {\n  .recap_img_large {\n    width: calc((100%) / 2);\n  }\n}\n\n@media (max-width: 576px) {\n  .recap_img_large {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .all_content_article_create {\n    width: 100%;\n  }\n\n  .article_create_stepper {\n    overflow-x: auto;\n  }\n\n  .article_create_step_circle {\n    width: 35px;\n    height: 31px;\n  }\n\n  .article_create_step_item {\n    gap: 7px;\n    justify-content: center;\n  }\n\n  .article_create_step_item.active .article_create_step_circle {\n    transform: scale(1.15);\n  }\n\n  .recap_img_large {\n    flex: 0 0 100%;\n  }\n\n  .info_cle_row {\n    grid-template-columns: 20px 120px 1fr;\n    gap: 8px;\n  }\n\n  .info_cle_name {\n    font-size: 0.85rem;\n  }\n\n  .info_cle_value {\n    font-size: 0.85rem;\n  }\n\n  .photo-flex-container {\n    justify-content: center;\n  }\n\n  .photo-upload-card-flex {\n    width: 50%;\n  }\n\n  .main_label_principale {\n    top: 0;\n    left: 0;\n  }\n\n  .article_create_form_section_create label {\n    width: 48%;\n  }\n\n  .photo-card-flex {\n    width: 47%;\n  }\n\n  .carousel_btn.right {\n    right: 5px;\n  }\n\n  .payment_instructions {\n    flex-direction: column;\n  }\n\n  .payment_methods_flex {\n    flex-direction: row;\n    gap: 5px;\n  }\n\n  .payment_box {\n    width: 80px;\n    height: 50px;\n    gap: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
